import * as React from "react";
import { Container, Box, Paper, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import parse from 'html-react-parser';

import theme, { getColor } from "utils/theme";

const ServiceList = props => {
	const { services: servicesOffered, title, text } = props;

	const sectionStyle = {
		position: 'relative',
		padding: '288px 0 106px',
		backgroundImage: `url(${process.env.CDN_DOMAIN||''}"/assets/backgrounds/tile-pattern-bg.svg")`,
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		backgroundSize: 'cover',
		[theme.breakpoints.down('laptop')]: {
			padding: '0 0 55px',
			backgroundPosition: '100% 0rem',
			backgroundSize: 'cover',
		},
		'&::before': {
			content: '""',
			position: "absolute",
			top: "0",
			left: "0",
			width: "0",
			height: "0",
			borderLeft: "0vw solid transparent",
			borderRight: "100vw solid transparent",
			borderTop: `75px solid ${getColor('blue', 700)}`,
			[theme.breakpoints.down('laptop')]: {
				display: 'block',
				position: "initial",
				marginBottom: "3rem",
			}
		}
	};

	//const [activeCopy, setActiveCopy] = React.useState(servicesOffered[0].copy);
	//const [activeIndex, setActiveIndex] = React.useState(0);
	//const [fadeIn, setFadeIn] = React.useState(true);

	//React.useEffect(() => {
	//	setActiveCopy(servicesOffered[0].copy);
	//	setActiveIndex(0);
	//}, [servicesOffered]);

	//const handleCopyClick = (index) => {
	//	if (!servicesOffered[index].copy) return; // Prevent update if there's no copy

	//	setFadeIn(false);
	//	setTimeout(() => {
	//		setActiveCopy(servicesOffered[index].copy);
	//		setActiveIndex(index);
	//		setFadeIn(true);
	//	}, 200); // Briefly hide before fading in
	//};


	return (
		<Box sx={sectionStyle} component="section">
			<Container>
				<Grid gap={0} container>
					<Grid size={{ sm: 12 }}>
						<Typography fontWeight={600} sx={{ marginBottom: "9px" }} variant={'h2CardTitle'}>
							{title}
						</Typography>
					</Grid>
					<Grid size={{ sm: 12, md: 9 }}>
						<Box sx={{ marginBottom: "30px" }}>
							{text ? parse(text) : ''}
						</Box>
					</Grid>
					<Grid size={{ sm: 12 }}>
						<Box display={'flex'} flexWrap={'wrap'} gap={'8px'} sx={{ marginBottom: "60px" }}>
							{servicesOffered?.length && servicesOffered.map((item, index) => {
								const { name } = item;
								return (
									//<Link key={index} onClick={(e) => { e.preventDefault(); handleCopyClick(index) }} href="#" sx={{ textDecoration: 'none' }}>
									<Paper key={index} className={`label__chip ghost`} variant="label" size="lg">
										<Box component="span" className="topic__chip__label">{name}</Box>
									</Paper>
									//</Link>
								);
							})}
						</Box>
						{/*<Fade in={fadeIn} timeout={500}>
							<Box>
								{parse(activeCopy ? activeCopy : '')}
							</Box>
						</Fade>*/}
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
}

export default ServiceList;